import React from "react"

import classnames from "classnames"

import { useTranslations } from "@cirrus/core/i18n"
import StatelessTextInput from "@cirrus/legacy/app-components/form-controls/inputs/stateless-text-input/index.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import {
  globalHotkeysLockId,
  lockHotkeys
  // @ts-ignore
} from "@cirrus-delivery/v1/_redux/exam/shared/services/hotkeysLock.es6"

import { MatchesCountSpan, SearchContainer, WrapSearch } from "./parts"
import { IPdfSearchProps } from "./props"
import { useStyles } from "./styles"
import { useSearch } from "./useSearch"

export const PdfSearch = (props: IPdfSearchProps) => {

  const styles = useStyles()
  const {
    state,
    searchRef,
    handleSearch,
    onPrevMatch,
    onNextMatch,
    toggleSearch,
    handleBlur
  } = useSearch(props)
  const { i18n } = useTranslations()

  return (
    <SearchContainer>
      <Icon icon={"fa-search"} onClick={() => toggleSearch(true)} className={styles.icon} />

      <WrapSearch
        className={classnames({
          [styles.hidden]: !(state.isOpened || state.query)
        })}>
        <StatelessTextInput
          autoComplete="off"
          setRef={(element) => searchRef.current = element}
          placeholder={i18n("General:Search")}
          className={styles.search}
          value={state.query}
          onChange={handleSearch}
          onKeyDown={(e) => {
            const keyCode = e.which || e.keyCode

            if (keyCode === 13) {
              e.preventDefault()
              e.stopPropagation()
              e.shiftKey ? onPrevMatch() : onNextMatch()
            } else if (keyCode === 27) {
              e.preventDefault()
              e.stopPropagation()
              searchRef.current?.blur()
            }
          }}
          onBlur={handleBlur}
          onFocus={() => lockHotkeys(globalHotkeysLockId)}
          ariaLabel={i18n("General:Search")}
        />

        <Icon icon={"fa-angle-left"} onClick={onPrevMatch} className={styles.icon} />

        {state.query && props.matchesCount ? (
          <MatchesCountSpan>
            {props.matchesCount.current} / {props.matchesCount.total}
          </MatchesCountSpan>
        ) : null}

        <Icon icon={"fa-angle-right"} onClick={onNextMatch} className={styles.icon} />

      </WrapSearch>
    </SearchContainer>

  )
}
